/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { yookassaPaymentCallbackRequestSchema } from "./yookassaPaymentCallbackRequestSchema.ts";

export const paymentYookassaCallbackCreateStatus200Schema = z.any();

export const paymentYookassaCallbackCreateResponseSchema = paymentYookassaCallbackCreateStatus200Schema;

export const paymentYookassaCallbackCreateDataSchemaJson = yookassaPaymentCallbackRequestSchema;

export const paymentYookassaCallbackCreateDataSchemaXml = yookassaPaymentCallbackRequestSchema;

export const paymentYookassaCallbackCreateDataSchema = z.union([paymentYookassaCallbackCreateDataSchemaJson, paymentYookassaCallbackCreateDataSchemaXml]);
